var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelefone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8627 25.7254C5.77265 25.7254 0 19.9527 0 12.8627C0 5.77263 5.77265 0 12.8627 0C19.9527 0 25.7254 5.77263 25.7254 12.8627C25.7254 19.9527 19.9527 25.7254 12.8627 25.7254ZM12.8627 1.38331C6.53315 1.38331 1.38329 6.53313 1.38329 12.8627C1.38329 19.1922 6.53315 24.3422 12.8627 24.3422C19.1922 24.3422 24.3421 19.1922 24.3421 12.8627C24.3421 6.53313 19.1922 1.38331 12.8627 1.38331Z",
    fill: "#EC681C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3431 15.0064C17.7323 14.6412 16.9418 14.2339 16.2232 14.5274C15.6723 14.7549 15.319 15.6113 14.9657 16.0544C14.7801 16.2819 14.5645 16.3179 14.283 16.2041C12.2171 15.3837 10.6362 14.0004 9.49247 12.1021C9.30085 11.8087 9.33678 11.5752 9.56433 11.2998C9.91164 10.8926 10.3428 10.4314 10.4326 9.88649C10.5284 9.34156 10.2709 8.7008 10.0434 8.21576C9.75594 7.59298 9.43258 6.70681 8.80981 6.3535C8.23494 6.03014 7.48042 6.20976 6.97142 6.62894C6.09115 7.34752 5.666 8.46728 5.67798 9.58109C5.67798 9.89846 5.7199 10.2159 5.79176 10.5213C5.9714 11.2578 6.30674 11.9405 6.68999 12.5932C6.97742 13.0842 7.28882 13.5633 7.63014 14.0184C8.73797 15.5215 10.1093 16.8208 11.7021 17.7969C12.4986 18.2819 13.3549 18.7131 14.2411 19.0065C15.2352 19.3359 16.1214 19.6772 17.1993 19.4736C18.3251 19.2581 19.4329 18.5634 19.8761 17.4795C20.0078 17.1561 20.0736 16.8029 20.0018 16.4615C19.8461 15.7609 18.9 15.3418 18.3311 15.0064H18.3431Z",
    fill: "#EC681C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelefone);
export default __webpack_public_path__ + "static/media/telefone.f29c5b8f6a4843b5d6e5430f7c0126cd.svg";
export { ForwardRef as ReactComponent };